module.exports = __webpack_public_path__ + "fonts/MessinaSansWeb-SemiBold.16d8b153.woff";